module.exports = __webpack_public_path__ + "static/media/Logo__Autonation.6c61dee6.svg";